import PropTypes from "prop-types"
import React, { useState } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"

import OTPInput from "react-otp-input"

// import { Form, ErrorMessage } from "formik"
// import * as Yup from "yup"

// action
import { otpApprove } from "../../store/session/actions"

// import images
import profile from "../../assets/images/profile-img.png"
// import logo from "../../assets/images/logo.svg"
import otpLogo from "../../assets/images/otp-logo.png"
import "./styles.scss"

function OtpApprovePage(props) {
  const employeeId = localStorage.getItem("empId")
  const loginDevice = localStorage.getItem("MachineId")

  console.log(employeeId, "empId")
  console.log(loginDevice, "loginDevice")

  const [OTP, setOTP] = useState("")
  const handleChange = (OTP) => {
    setOTP(OTP)
  }

  console.log(OTP, "otp list")

  const verifyOtp = () => {
    const otpDetails = {
      otp: OTP,
      employeeId: employeeId,
      loginDevice: loginDevice,
    }
    props.otpApprove(otpDetails)
  }
  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Enter the Otp to continue.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={otpLogo}
                            alt=""
                            className="rounded-circle w-100 h-100"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  {/* <div className="p-2"> */}
                  {/* {props.error && props.error ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {props.error}
                      </Alert>
                    ) : null}
                    {props.success ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {props.success}
                      </Alert>
                    ) : null} */}

                  {/* <Formik
                      enableReinitialize={true}
                      initialValues={{
                        otp: "",
                        employeeId: employeeId,
                        loginDevice: loginDevice,
                      }}
                      validationSchema={Yup.object().shape({
                        otp: Yup.string()
                          .required("Please Enter Your Otp")
                          .matches(/^[0-9]+$/, "Must be only digits")
                          .min(6, "Must be exactly 6 digits only")
                          .max(6, "Must be exactly 6 digits only"),
                      })}
                      onSubmit={(values) => {
                        props.otpApprove(values, props.history)
                      }}
                    >
                      {({ errors, touched }) => ( */}
                  <div className="verifyDiv">
                    <p className="otp-para-1">Verify Account</p>
                    <p className="otp-para-3">Enter your Code here</p>
                    <div className="otpElements">
                      <div className="otp">
                        <OTPInput
                          name="OTP"
                          numInputs={6}
                          onChange={handleChange}
                          value={OTP}
                          separator={<span>-</span>}
                          autoFocus
                          // OTPLength={4}
                          inputStyle="inputStyle"
                          otpType="number"
                          disabled={false}
                          secure
                          // className={
                          //   (errors.otp && touched.otp ? " is-invalid" : "")
                          // }
                        />
                      </div>
                    </div>
                    <div className="text-center">
                      <button
                        className="btn btn-primary w-md"
                        type="submit"
                        onClick={() => verifyOtp()}
                      >
                        Verify Otp
                      </button>
                    </div>
                    {/* )}
                    </Formik> */}
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link to="login" className="fw-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Powered by Alphaone. All Rights
                  Reserved.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

OtpApprovePage.propTypes = {
  dispatch: PropTypes.func,
  error: PropTypes.func,
  success: PropTypes.string,
  history: PropTypes.object,
  otpApprove: PropTypes.any,
}

const mapStateToProps = (state) => {
  const { error, success } = state.session
  return { error, success }
}

export default withRouter(
  connect(mapStateToProps, { otpApprove })(OtpApprovePage)
)
